<template>
    <div class="ah-dropdown-date-picker">
        <el-select v-model="year" placeholder="年" class="year-select" @change="onSelect" filterable default-first-option>
            <template v-if="useChineseYear">
                <el-option v-for="y in yearOptions" :key="y" :value="y" :label="`${y - 1911} 年`">
                    <div :class="{'ah-dropdown-date-picker_quick-option': quickButton}">
                        <span>{{ y - 1911 }} 年</span>
                        <el-button v-if="quickButton" size="mini" round @click="onFullYearClick(y)">整年</el-button>
                    </div>
                </el-option>
            </template>
            <template v-else>
                <el-option v-for="y in yearOptions" :key="y" :value="y" :label="`${y} 年`" @change="onSelect" filterable default-first-option>
                    <div :class="{'ah-dropdown-date-picker_quick-option': quickButton}">
                        <span>{{ y }} 年</span>
                        <el-button v-if="quickButton" size="mini" round @click="onFullYearClick(y)">整年</el-button>
                    </div>
                </el-option>
            </template>
        </el-select>
        <el-select v-model="startMonth" placeholder="月" class="month-select in-middle" @change="onSelect" filterable default-first-option>
            <el-option v-for="m in 12" :key="m" :value="m" :label="`${m} 月`">
                <div :class="{'ah-dropdown-date-picker_quick-option': quickButton}">
                    <span>{{ m }} 月</span>
                    <el-button v-if="quickButton" size="mini" round @click="onFullMonthClick(m)">整月</el-button>
                </div>
            </el-option>
        </el-select>
        <el-select v-model="startDate" placeholder="日" class="date-select" @change="onSelect" filterable default-first-option>
            <el-option v-for="d in startMonthDates" :key="d" :value="d" :label="`${d} 日`">{{ d }} 日</el-option>
        </el-select>
        <template  v-if="showEndPicker">
            <span class="spacer">至</span>
            <el-select v-model="endMonth" placeholder="月" class="month-select" @change="onSelect" filterable default-first-option>
                <el-option v-for="m in 12" :key="m" :value="m" :label="`${m} 月`">
                    <div :class="{'ah-dropdown-date-picker_quick-option': quickButton}">
                        <span>{{ m }} 月</span>
                        <el-button v-if="quickButton" size="mini" round @click="onFullMonthClick(m)">整月</el-button>
                    </div>
                </el-option>
            </el-select>
            <el-select v-model="endDate" placeholder="日" class="date-select" @change="onSelect" filterable default-first-option>
                <el-option v-for="d in endMonthDates" :key="d" :value="d" :label="`${d} 日`">{{ d }} 日</el-option>
            </el-select>
        </template>
    </div>
</template>
<script>
import moment from 'moment';

export default {
    props: {
        value: {
            type: Array,
            default: () => [],
        },
        startYear: {
            type: Number,
            default: 2020,
        },
        endYear: {
            type: Number,
            default: null,
        },
        addYears: {
            type: Number,
            default: 0,
        },
        useChineseYear: {
            type: Boolean,
            default: true,
        },
        showEndPicker: {
            type: Boolean,
            default: true,
        },
        quickButton: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            year: null,
            startMonth: null,
            startDate: null,
            endMonth: null,
            endDate: null,
        };
    },
    watch: {
        value(newValue) {
            const startDate = moment(parseInt(newValue[0], 10));
            const endDate = moment(parseInt(newValue[1], 10));
            if (startDate) {
                this.year = startDate.year();
                this.startMonth = startDate.month() + 1;
                this.startDate = startDate.date();
            }
            if (endDate) {
                this.endMonth = endDate.month() + 1;
                this.endDate = endDate.date();
            }
        },
    },
    computed: {
        yearOptions() {
            let endYear = this.endYear ? this.endYear : new Date().getFullYear() + this.addYears;
            if (endYear < this.startYear) {
                endYear = this.startYear;
            }
            const options = [];
            for (let y = this.startYear; y <= endYear; y += 1) {
                options.push(y);
            }
            options.reverse();
            return options;
        },
        startMonthDates() {
            const days = moment(`${this.year}-${this.startMonth}`, 'YYYY-MM').daysInMonth();
            return days || 31;
        },
        endMonthDates() {
            const days = moment(`${this.year}-${this.endMonth}`, 'YYYY-MM').daysInMonth();
            return days || 31;
        },
    },
    methods: {
        onFullYearClick(targetYear) {
            this.year = targetYear;
            this.startMonth = 1;
            this.startDate = 1;
            this.endMonth = 12;
            this.endDate = 31;
            this.onSelect();
            this.$emit('onFullYearClick', this.getOutputValue());
        },
        onFullMonthClick(targetMonth) {
            this.startMonth = targetMonth;
            this.endMonth = targetMonth;
            this.startDate = 1;
            this.endDate = 31;
            this.onSelect();
            this.$emit('onFullMonthClick', this.getOutputValue());
        },
        onSelect() {
            this.$emit('input', this.getOutputValue());
            this.$nextTick(() => {
                this.$emit('change');
            });
        },
        getOutputValue() {
            let startDatetime = null;
            let endDatetime = null;
            // console.log('year', this.year);
            // console.log('startMonth', this.startMonth);
            // console.log('startDate', this.startDate);
            // console.log('endMonth', this.endMonth);
            // console.log('endDate', this.endDate);

            // date correction
            const startMonthDays = moment(`${this.year}-${this.startMonth}`, 'YYYY-MM').daysInMonth();
            if (this.startDate > startMonthDays) {
                this.startDate = startMonthDays;
            }

            const endMonthDays = moment(`${this.year}-${this.endMonth}`, 'YYYY-MM').daysInMonth();
            if (this.endDate > endMonthDays) {
                this.endDate = endMonthDays;
            }

            // format
            if (this.year
                && this.startMonth
                && this.startDate
            ) {
                startDatetime = +moment(`${this.year}-${this.startMonth}-${this.startDate}`).startOf('day').format('x');
            }

            if (this.year
                && this.endMonth
                && this.endDate
            ) {
                endDatetime = +moment(`${this.year}-${this.endMonth}-${this.endDate}`).endOf('day').format('x');
            }

            return [startDatetime, endDatetime];
        },
    },
};
</script>
<style lang="scss">
.ah-dropdown-date-picker {
    .el-select {
        &.year-select {
            width: 105px;
            .el-input__inner {
                text-align: center;
                // border-right: 0;
                border-top-right-radius: 0;
                border-bottom-right-radius: 0;
            }
        }
        &.month-select {
            position: relative;
            left: -2px;
            width: 80px;
            .el-input__inner {
                text-align: center;
                border-top-right-radius: 0;
                border-bottom-right-radius: 0;
                // border-right: 0;
            }
            &.in-middle {
                .el-input__inner {
                    border-top-left-radius: 0;
                    border-bottom-left-radius: 0;
                }
            }
        }
        &.date-select {
            position: relative;
            left: -4px;
            width: 80px;
            .el-input__inner {
                text-align: center;
                border-top-left-radius: 0;
                border-bottom-left-radius: 0;
            }
        }
        .el-input.is-focus {
            position: relative;
            z-index: 2;
        }
    }
    .spacer {
        position: relative;
        left: -4px;
        font-size: 10pt;
        color: #666;
        padding: 0 5px;
    }
}
.ah-dropdown-date-picker_quick-option {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 120px;

    .el-button {
        padding: 0px 10px;
        line-height: 22px;
        height: 23px;
        font-size: 8pt;
    }
}
</style>
